import { TrendingUp } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangPhanTich } from './pages/TrangPhanTich.js';

const analytics: KhaiBaoModule = {
  id: 'analytics',
  nav: {
    group: 'VẬN HÀNH',
    label: 'Hiệu suất',
    icon: TrendingUp,
    order: 4,
    permission: 'analytics',
    to: '/phan-tich',
  },
  routes: [
    {
      path: '/phan-tich',
      element: createElement(TrangPhanTich),
      permission: { module: 'analytics', level: 'view' },
    },
  ],
};

export default analytics;
